export default {"src":"https://fishbrain.com/_next/static/media/2.62b2e104.svg","height":513,"width":513,"blurWidth":0,"blurHeight":0};